import React, { ReactElement } from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import { useGetGeneralCbiEntityInfo } from 'client/modules/cbi-entity/services/general-info/hooks/useGetGeneralCbiEntityInfo';
import { IdType } from '@cbinsights/cbientityservice/cbientityservice';
import moment from 'moment';
import PackageLink from 'client/modules/packages/components/PackageLink';
import { ChangePackageModal } from '../ChangePackageModal';
import EntityLinking from '../EntityLinking';

type Props = {
  packageId: number;
  packageName: string;
  packageStart?: string;
  packageEnd?: string;
  refetchTeam?: () => void;
  linkedEntity?: number;
  idTeam: number;
};

export const PackageSetting = ({
  packageId,
  packageName,
  packageStart,
  packageEnd,
  refetchTeam,
  linkedEntity,
  idTeam,
}: Props): ReactElement => {
  const { data: entityInfo, isLoading: isLoadingEntity } =
    useGetGeneralCbiEntityInfo(Boolean(linkedEntity), {
      id: linkedEntity,
      idType: IdType.CBI_ENTITY,
    });

  return (
    <Col
      xl={{ push: 2, span: 6 }}
      md={{ push: 2, span: 20 }}
      xs={{ push: 1, span: 22 }}
    >
      <Typography.Title level={4} className="!font-medium mt-4">
        Package Setting
      </Typography.Title>
      <Divider className="border-t-2 border-black border-solid" />
      <Row justify="space-between" align="bottom">
        <Col span="8">
          <Typography.Title level={5} className="!font-medium">
            Team Package
          </Typography.Title>
        </Col>
        <Col span="8" className="text-center">
          <PackageLink
            idPackage={packageId}
            name={packageName}
            fallback="No Package Selected"
          />
        </Col>
      </Row>
      <Row justify="space-between" align="bottom">
        <Col span="8">
          <Typography.Title level={5} className="!font-medium">
            Start Date
          </Typography.Title>
        </Col>

        <Col span="8" className="text-center">
          {packageStart && moment(packageStart).format('MM-DD-YYYY')}
        </Col>
      </Row>
      <Row justify="space-between" align="bottom">
        <Col span="8">
          <Typography.Title level={5} className="!font-medium">
            End Date
          </Typography.Title>
        </Col>

        <Col span="8" className="text-center">
          {packageEnd && moment(packageEnd).format('MM-DD-YYYY')}
        </Col>
      </Row>
      <Row justify="space-between" align="bottom">
        <Col span="8">
          <Typography.Title level={5} className="!font-medium">
            Linked Entity
          </Typography.Title>
        </Col>
        <Col span="8" className="text-center">
          <EntityLinking
            entity={entityInfo}
            isLoading={isLoadingEntity}
            onEntityChange={refetchTeam}
            idTeam={idTeam}
          />
        </Col>
      </Row>
      <Row justify="center">
        <ChangePackageModal
          refetchTeam={refetchTeam}
          packageName={packageName}
          packageID={packageId}
          packageStart={packageStart}
          packageEnd={packageEnd}
        />
      </Row>
    </Col>
  );
};

export default PackageSetting;
